import styled from "@emotion/styled";
import Menu from "@mui/material/Menu";
import { Popover, TextField } from "@mui/material";

export const SearchMenuBox = styled(Popover)`
  .MuiPaper-root {
    left: 68px !important;
    top: 12px !important;
    border-radius: 16px 16px 16px 16px !important;
    min-width: 380px;
    padding: 20px;
    overflow: visible;
    max-width: 480px;
    box-shadow: unset;
    background-image: unset;
    /* box-shadow:
      rgb(255, 255, 255) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px; */
    /* filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.32)); */
    background-color: ${({ theme }) => theme.palette.grey.g6};
    height: 100%;
  }
`;

export const SettingMenuBox = styled(Popover)`
  .MuiPaper-root {
    /* display: flex; */
    justify-content: center;
    align-items: center;
    text-align: center;
    /* width: auto; */
    position: absolute;
    /* height: 600px; */
    left: 68px !important;
    bottom: 0px !important;
    border-radius: 16px 16px 16px 16px !important;
    min-width: 480px;
    padding: 8px;
    overflow: visible;
    max-width: 480px;
    box-shadow: unset;
    background-image: unset;
    /* box-shadow:
      rgb(255, 255, 255) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px; */
    /* filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.32)); */
    background-color: ${({ theme }) => theme.palette.grey.g6};
  }
`;

export const SideMenuBox = styled(Popover)`
  .MuiPaper-root {
    /* display: flex; */
    justify-content: center;
    align-items: center;
    text-align: center;
    /* width: auto; */
    position: absolute;
    /* height: 600px; */
    left: 68px !important;
    bottom: 0px !important;
    top: unset !important;
    border-radius: 16px 16px 16px 16px !important;
    min-width: 480px;
    padding: 8px;
    overflow: visible;
    max-width: 480px;
    box-shadow: unset;
    background-image: unset;
    /* box-shadow:
      rgb(255, 255, 255) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px; */
    /* filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.32)); */
    background-color: ${({ theme }) => theme.palette.grey.g6};
  }
`;

export const SearchTextField = styled(TextField)`
  > div {
    padding-left: 5px;
  }
  .MuiInputBase-root {
    border-radius: 30px;
    background-color: ${({ theme }) => theme.palette.grey.g5};
    input {
      padding: 13px;
    }
  }
`;

export const ProMenuBox = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    position: "absolute",
    right: "unset !important",
    left: "60px !important",
    bottom: "250px !important",
    top: "250px !important",
    boxShadow: "unset",
    backgroundImage: "unset",
    borderRadius: "8px !important",
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.grey.g6,
    minWidth: 250,
    maxHeight: 250,

    "& .MuiMenu-list": {
      padding: "10px",
      "& > li.active": {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        borderRadius: `${theme.shape.borderRadius}px`,
      },
    },
  },
}));
